import moment from 'moment';
import React from 'react';
import ExcelFile from 'react-data-export/dist/ExcelPlugin/components/ExcelFile';
import ExcelColumn from 'react-data-export/dist/ExcelPlugin/elements/ExcelColumn';
import ExcelSheet from 'react-data-export/dist/ExcelPlugin/elements/ExcelSheet';
import { getLocalizedDateTime, getLocalizedName } from '../../localization/LocalizedString';

const getShipmentId = (order) => {
  const { devices } = order;
  let shipmentId = '';
  if (devices != null && devices.length > 0) {
    shipmentId = devices[0].shipmentId;
  }
  return shipmentId;
};

const getCreatedAt = (order, language) => {
  const { createdAt } = order;
  return getLocalizedDateTime(new Date(createdAt), language);
};

const getContractorName = (order, language) => {
  const {
    orderData: {
      subcontractor,
    },
  } = order;
  return getLocalizedName(subcontractor, language);
};

const getCustomerInfo = (order, field) => {
  const {
    customer,
  } = order;
  return customer[field];
};

const getAgreementDate = (order, translate) => {
  const {
    status: {
      timeAgreementDates,
    },
  } = order;
  let timeAgreementDate = '';
  if (timeAgreementDates != null && timeAgreementDates.length > 0) {
    const lastAddedAgreementDate = timeAgreementDates[timeAgreementDates.length - 1];
    if (lastAddedAgreementDate != null) {
      const { startDate, endDate } = lastAddedAgreementDate;
      if (startDate != null && endDate != null) {
        const dateFmt = translate('work_list.column_task.agreement-date-format');
        const timeFmt = translate('work_list.column_task.agreement-time-format');
        timeAgreementDate = `${moment(startDate)
          .format(dateFmt)}-${moment(endDate)
          .format(timeFmt)}`;
      }
    }
  }
  return timeAgreementDate;
};

const getStatus = (order, translate) => {
  const {
    status: {
      value,
    },
  } = order;
  return translate(`work_list.status.${value}`);
};

const getDevicesNames = (order, language) => {
  const { devices } = order;
  return devices.map((it) => getLocalizedName(it, language))
    .join(', ');
};

const getProductNames = (order, language) => {
  const { orderData: { deviceAdditionalProducts } } = order;
  return deviceAdditionalProducts.map((it) => getLocalizedName(it, language))
    .join(', ');
};

const ExcelResult = ({ data, translate, language }) => {
  const title = language === 'fi'
    ? 'Työlista'
    : 'Work list';
  return (
    <ExcelFile hideElement filename={title}>
      <ExcelSheet data={data} name={translate('navigation.worklist')}>
        <ExcelColumn label={translate('work_list.column_task.shipmentId')} value={getShipmentId} />
        <ExcelColumn label={translate('work_list.column_task.createdAt')} value={(order) => getCreatedAt(order, language)} />
        <ExcelColumn label={translate('work_list.column_task.subcontractorName')} value={(order) => getContractorName(order, language)} />
        <ExcelColumn label={translate('work_list.column_task.customerName')} value={(order) => getCustomerInfo(order, 'name')} />
        <ExcelColumn label={translate('work_list.column_task.customerStreetAddress')}
                     value={(order) => getCustomerInfo(order, 'streetAddress')} />
        <ExcelColumn label={translate('work_list.column_task.customerPostalCode')}
                     value={(order) => getCustomerInfo(order, 'postalCode')} />
        <ExcelColumn label={translate('work_list.column_task.devicesName')} value={(order) => getDevicesNames(order, language)} />
        <ExcelColumn label={translate('work_list.column_task.deviceAdditionalProductName')}
                     value={(order) => getProductNames(order, language)} />
        <ExcelColumn label={translate('work_list.column_task.customerCity')} value={(order) => getCustomerInfo(order, 'city')} />
        <ExcelColumn label={translate('work_list.column_task.customerPhone')} value={(order) => getCustomerInfo(order, 'phone')} />
        <ExcelColumn label={translate('work_list.column_task.date')} value={(order) => getAgreementDate(order, translate)} />
        <ExcelColumn label={translate('work_list.column_task.status')} value={(order) => getStatus(order, translate)} />
        <ExcelColumn label={translate('service_installation.installation_parking_info')} value={(order) => getCustomerInfo(order, 'parkingInfo')} />
      </ExcelSheet>
    </ExcelFile>
  );
};

export default ExcelResult;



// WEBPACK FOOTER //
// ./src/components/worklist/ExcelResult.js